import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	heading: {
		marginLeft: '2rem',
		marginBottom: '1rem',
		color: theme.palette.primary.main,
		textAlign: 'center',
		fontWeight: 600,
		fontSize: theme.typography.pxToRem(20)
	},
	subHeading: {
		marginLeft: '2rem',
		marginBottom: '1rem',
		color: theme.palette.primary.main,
		textAlign: 'center',
		fontWeight: 600,
		fontSize: theme.typography.pxToRem(16)
	},
	buttonWrapper: {
		display: 'flex',
		justifyContent: 'center',
		margin: '2rem',
		columnGap: '1rem'
	},
	inputHeading: {
		fontWeight: '600',
		color: theme.palette.primary.main,
		padding: 0,
		textAlign: 'left'
	},
	icon: {
		cursor: 'pointer',
		transform: 'scale(1.5)',
		transition: 'all .3s ease !important',
		'&:hover': {
			transform: 'scale(1.55)'
		},
		'&:active': {
			transform: 'scale(1.3)'
		}
	},
	videoConfig: {
		marginTop: '1rem',
		width: '100%'
	},
	tableWrapper: {
		zIndex: '1!important',
		display: 'flex',
		flexDirection: 'column',
		rowGap: '10px'
	}
}));
